import { Button, Checkbox, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router';
import CustomInput from './CustomInput';
import { useSkyContext } from '../store/provider';
import logo from '../assets/1_Transparent_Image.png';
import { DEFAULT_URL } from '../constants';

const SigninPage: React.FC = () => {
  const [value, setValue] = useState('Initial value');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const skyContext = useSkyContext();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [invalidField, setInvalidField] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);

  const handleUsernameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(event.target.value);
    skyContext.setFields({ value: skyContext.value + event.target.value });
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const keyPressed = async (event: any) => {
    console.log(event, 'keyPressed');
    if (event.key === 'Enter') {
      handleLogin();
    }
  };

  useEffect(() => {
    console.log(invalidField, 'invalidField input');
  }, [invalidField]);
  const handleLogin = async () => {
    try {
      setLoading(true);
      const response = await axios({
        method: 'post',
        url: `${DEFAULT_URL}login`,
        data: { username, password },
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      });

      if (response.status === 200) {
        console.log(response.data.user, 'response.data.user sigin page :::');
        skyContext.setFields({
          user: response.data.user,
          isAuthenticated: true,
        });
        navigate('/cockpit');
      }
      // Navigate to the next page if login is successful
    } catch (error: any) {
      console.error('Error logging in:', error?.response?.data);
      setInvalidField(true);
      skyContext.setFields({
        snackbar: {
          severity: 'error',
          onOpen: true,
          msg: error?.response?.data?.info?.message || 'Internal Error',
          isAuthenticated: false,
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSessionCheck = async () => {
    try {
      const response = await axios({
        method: 'get',
        url: `${DEFAULT_URL}check`,

        withCredentials: true,
      });
      console.log('Server response:', response.data);
      // Navigate to the next page if login is successful
    } catch (error) {
      console.error('Error logging in:', error);
    }
  };

  const handleLogout = async () => {
    console.log('SHIT IN THE ASS LOGGEDOUT');

    try {
      const response = await axios({
        method: 'get',
        url: `${DEFAULT_URL}logout`,

        withCredentials: true,
      });
      console.log('Server response:', response.data);
      // Navigate to the next page if login is successful
    } catch (error) {
      console.error('Error logging in:', error);
    }
  };
  return (
    <form
      className="main-container login-container"
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <div className="wrapper">
        <img src={logo} width="150" height="150" style={{ margin: '0 auto' }} />
        <CustomInput
          invalidField={(invalidField && true) || false}
          label="Username"
          placeholder="Enter your username..."
          isIconActive={false}
          value={username}
          onChange={handleUsernameChange}
        />
        <CustomInput
          invalidField={(invalidField && true) || false}
          label="Password"
          placeholder="Enter your password..."
          isIconActive={true}
          type={(passwordShown && 'text') || 'password'}
          value={password}
          onChange={handlePasswordChange}
          onIconClick={() => setPasswordShown(!passwordShown)}
          shownIcon={passwordShown}
        />
        {/* <div style={{ display: "flex" }}>
        <Checkbox disableRipple sx={{ p: 0, pr: 1 }} style={{color:"#124380"}} />
        <Typography>Remember me</Typography>
      </div> */}
        <Button
          //onClick={gotoQuestion}
          disabled={!username || !password}
          variant="outlined"
          fullWidth
          sx={{
            mt: 4,
            boxShadow: '0 0 10px #124380',
            color: '#124380',
            borderRadius: '10px',
          }}
          onClick={handleLogin}
          onKeyPress={keyPressed}
          type="submit"
        >
          {(loading && 'loading...') || 'Login'}
        </Button>
      </div>
    </form>
    //         <Grid container height="90vh">

    // <Grid
    //   xs={12}
    //   sm={12}
    //   md={6}
    //   lg={6}
    //   xl={6}
    //   minHeight={550}
    //   sx={{
    //     boxShadow: {
    //       xs: "",
    //       sm: "",
    //       md: "15px 2px 5px -5px",
    //       lg: "15px 2px 5px -5px",
    //       xl: "15px 2px 5px -5px",
    //     },
    //   }}
    // >
    //   <Box
    //     sx={{
    //       backgroundColor: "rgba(0, 24, 57, 0.2)",
    //       display: "flex",
    //       flexDirection: "column",
    //       alignItems: "center",
    //       height: "100%",
    //       borderRadius: {
    //         xs: "30px",
    //         sm: "30px",
    //         md: "30px 0 0 30px",
    //         lg: "30px 0 0 30px",
    //         xl: "30px 0 0 30px",
    //       },
    //     }}
    //   >
    //     <Box width="50%">
    //       <Box display="flex" flexDirection="column" alignItems="center">
    //         {/* LOGO */}
    //         <Box
    //           sx={{
    //             mt: "60px",
    //             width: "200px",
    //             height: "50px",
    //             bgcolor: "primary.main",
    //             borderRadius: "12px",
    //             display: "flex",
    //             alignItems: "center",
    //             justifyContent: "center",
    //             boxShadow: `0 0 20px #1891c6`,
    //           }}
    //         >

    //           <Typography variant="h6" fontWeight="bold" color="white">
    //             SkyCommerce
    //           </Typography>
    //         </Box>
    //         {/* LOGO END */}

    //         <Typography color="white" fontWeight="bold" sx={{ textAlign: 'center', marginTop: 4,  marginBottom: 0}} mt={7} mb={1}>

    //         </Typography>
    //         <Typography color="white" fontWeight="bold" sx={{ textAlign: 'center', margin: 0 }} mt={7} mb={3}>
    //         </Typography>
    //         <Typography color="white" fontWeight="bold" sx={{ textAlign: 'center', marginTop: 4 }} mt={7} mb={3}>
    //           Sign in to our SkyCommerce
    //         </Typography>
    //       </Box>

    //       {/* INPUTS */}
    //       <CustomInput
    //         label="Username"
    //         placeholder="Enter your uersname..."
    //         isIconActive={false}
    //         value={username}
    //         onChange={handleUsernameChange}
    //       />
    //       <CustomInput
    //         label="Password"
    //         placeholder="Enter your password..."
    //         isIconActive={true}
    //         type="password"
    //         value={password}
    //         onChange={handlePasswordChange}
    //       />
    //       {/* <CustomInput
    //         label="MFA Code"
    //         placeholder="Enter your code..."
    //         isIconActive={true}
    //       /> */}
    //       {/* INPUT END */}

    //       <Box
    //         display="flex"
    //         flexDirection="row"
    //         justifyContent="space-between"
    //         mt={2}
    //         width="100%"
    //         color="white"
    //       >
    //         <div style={{ display: "flex" }}>
    //           <Checkbox disableRipple sx={{ p: 0, pr: 1 }} />
    //           <Typography>Remember me</Typography>
    //         </div>

    //       </Box>
    //       <Button
    //         //onClick={gotoQuestion}
    //         variant="contained"
    //         fullWidth
    //         sx={{ mt: 4, boxShadow: `0 0 20px #1891c6` }}
    //         onClick={handleLogin}
    //       >
    //         Login
    //       </Button>

    //       <Button
    //         //onClick={gotoQuestion}
    //         variant="contained"
    //         fullWidth
    //         sx={{ mt: 4, boxShadow: `0 0 20px #1891c6` }}
    //         onClick={handleSessionCheck}
    //       >
    //         CHECK
    //       </Button>
    //       <Button
    //         //onClick={gotoQuestion}
    //         variant="contained"
    //         fullWidth
    //         sx={{ mt: 4, boxShadow: `0 0 20px #1891c6` }}
    //         onClick={handleLogout}
    //       >
    //         LOGOUT
    //       </Button>
    //     </Box>
    //   </Box>
    // </Grid>
    // <TitleBox />
    //     </Grid>
  );
};

export default SigninPage;
